<template>
  <div class="scene-crossroad-mobile" :class="classList">

    <MapObject class="scene-crossroad-mobile__parking" src="/map/mobile_crossroad_parking.png" :animated="ready" type="mobile"></MapObject>
    <MapObject class="scene-crossroad-mobile__b6" src="/map/build_4f_long_left.png" :animated="ready" type="mobile"></MapObject>
    <MapObject class="scene-crossroad-mobile__b7" src="/map/build_4f_long_left.png" :animated="ready" type="mobile"></MapObject>
    <MapObject class="scene-crossroad-mobile__b8" src="/map/build_8f_1.png" :animated="ready" type="mobile"></MapObject>
    <MapObject class="scene-crossroad-mobile__b9" src="/map/build_5f_long_1.png" :animated="ready" type="mobile"></MapObject>
    <MapObject class="scene-crossroad-mobile__b4" src="/map/build_huawei.png" :animated="ready" type="mobile"></MapObject>
    <MapObject class="scene-crossroad-mobile__b5" src="/map/build_jet.png" :animated="ready" type="mobile"></MapObject>

    <MapObject class="scene-crossroad-mobile__trees" src="/map/mobile_crossroad_trees.png" :animated="ready" type="mobile"></MapObject>
    <MapObject class="scene-crossroad-mobile__lines" src="/map/mobile_crossroad_lines.png" :animated="ready" type="mobile"></MapObject>

    <MapObject class="scene-crossroad-mobile__b1" src="/map/build_8f_2.png" :animated="ready" type="mobile"></MapObject>
    <MapObject class="scene-crossroad-mobile__b2" src="/map/build_8f_2.png" :animated="ready" type="mobile"></MapObject>
    <MapObject class="scene-crossroad-mobile__b3" src="/map/build_14f.png" :animated="ready" type="mobile"></MapObject>
    <MapObject class="scene-crossroad-mobile__tl" src="/map/mobile_crossroad_tl.png" :animated="ready" type="mobile"></MapObject>

  </div>
</template>

<script>
  import Scene from './Scene.vue'

  export default {
    extends: Scene,
  }
</script>

<style lang="scss">
  .scene-crossroad-mobile {
    @include relative-units(365.13px, 470px, mobile)

  }

  .scene-crossroad-mobile__tl {
    left: 24%;
    top: 29%;
    width: 55%;
  }
  .scene-crossroad-mobile__lines {
    left: 30.6%;
    top: 46.2%;
    width: 38.3%;
  }
  .scene-crossroad-mobile__parking {
    left: 66%;
    top: 74%;
    width: 15%;
  }
  .scene-crossroad-mobile__trees {
    left: -5.3%;
    top: -0.5%;
    width: 103.4%;
  }
  .scene-crossroad-mobile__b1 {
    left: 10.9%;
    top: 17.2%;
    width: 12%;
  }
  .scene-crossroad-mobile__b2 {
    left: 20%;
    top: 21.3%;
    width: 12%;
  }
  .scene-crossroad-mobile__b3 {
    left: 35%;
    top: 21%;
    width: 13%;
  }
  .scene-crossroad-mobile__b4 {
    left: 12.7%;
    top: 46.3%;
    width: 12.5%;
  }
  .scene-crossroad-mobile__b5 {
    left: 1.6%;
    top: 51.5%;
    width: 12.5%;
  }
  .scene-crossroad-mobile__b6 {
    left: 43%;
    top: 63%;
    width: 20%;
  }
  .scene-crossroad-mobile__b7 {
    left: 32%;
    top: 68%;
    width: 20%;
  }
  .scene-crossroad-mobile__b8 {
    left: 55.4%;
    top: 74%;
    width: 13%;
  }
  .scene-crossroad-mobile__b9 {
    left: 77%;
    top: 45%;
    width: 23%;
  }
</style>
